import { createIcon } from '@chakra-ui/react';

export const Benefit1 = createIcon({
  displayName: `Benefit1`,
  viewBox: `0 0 55.287 47.372`,
  path: (
    <g transform="translate(0)">
      <g>
        <g>
          <g>
            <path
              transform="translate(-179.76 -872.66)"
              d="M201.436,920.03a4.183,4.183,0,0,1-3.423-1.851l-6.435-9.171-10.929-15.369a5,5,0,0,1-.893-2.865V877.365a4.629,4.629,0,0,1,3.117-4.514,4.105,4.105,0,0,1,4.651,1.659l6.238,8.889L204.5,898.5a7,7,0,0,1,1.278,4.046v12.775a4.627,4.627,0,0,1-3.119,4.514A4.031,4.031,0,0,1,201.436,920.03Zm-17.046-41.919v12.662a.362.362,0,0,0,.043.19l16.714,23.615V902.549a2.348,2.348,0,0,0-.429-1.375Z"
              fill="currentColor"
            />
          </g>
        </g>
      </g>
      <g transform="translate(12.962 .003)">
        <g>
          <path
            transform="translate(-188.15 -872.66)"
            d="m202.68 894.57a2.314 2.314 0 0 1-1.894-0.979l-12.21-17.272a2.317 2.317 0 0 1 3.785-2.676l12.208 17.272a2.318 2.318 0 0 1-1.889 3.655z"
            fill="currentColor"
          />
        </g>
      </g>
      <g transform="translate(29.261 .001)">
        <g>
          <g>
            <path
              transform="translate(-198.7 -872.66)"
              d="M203.042,920.029a4.037,4.037,0,0,1-1.227-.192,4.627,4.627,0,0,1-3.119-4.514V902.549a6.99,6.99,0,0,1,1.268-4.033l16.989-24.005a4.107,4.107,0,0,1,4.651-1.659,4.629,4.629,0,0,1,3.117,4.514v13.409a5,5,0,0,1-.885,2.856l-17.371,24.549A4.186,4.186,0,0,1,203.042,920.029Zm17.046-41.919-5.578,7.949-10.759,15.128a2.343,2.343,0,0,0-.42,1.361v12.029l5.777-8.23,10.945-15.393a.413.413,0,0,0,.036-.181Z"
              fill="currentColor"
            />
          </g>
        </g>
      </g>
      <g transform="translate(25.481 .595)">
        <g>
          <path
            transform="translate(-196.25 -873.04)"
            d="m198.57 894.36a2.318 2.318 0 0 1-1.891-3.655l11.79-16.679a2.317 2.317 0 1 1 3.785 2.675l-11.79 16.679a2.316 2.316 0 0 1-1.894 0.98z"
            fill="currentColor"
          />
        </g>
      </g>
    </g>
  ),
});
